import { Memo } from "../../models/memo";
import { CheckInMemoCell } from "./checkInMemoCell";
import { useTranslation } from "react-i18next";

export function CheckInMemoTable({ memoList }: { memoList: Memo[] }) {
  const { t } = useTranslation();
  return (
    <>
      {memoList.length === 0 && (
        <div>
          <span>{t("eventdetail_cloudmemo_emptystate")}</span>
        </div>
      )}
      {memoList.length > 0 && (
        <div>
          {memoList.map((memo) => (
            <CheckInMemoCell key={memo.id} memo={memo} />
          ))}
        </div>
      )}
    </>
  );
}
